//import { HttpClient             } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { filter, find, findIndex, get, isNumber } from 'lodash';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { empty } from 'rxjs/observable/empty';
import { of } from 'rxjs/observable/of';
import { ISwipeResponse, IUserListResponse } from "../../typings/api";
import { IUser } from "../../typings/timetracker/timetracker";
import { TimeTrackerBaseApi } from './generic.service';



@Injectable()
export class UserService {

    constructor( private $api: TimeTrackerBaseApi ) {}

    private list$ = new BehaviorSubject<IUserListResponse>(undefined);
    private swipes$ = new BehaviorSubject<ISwipeResponse[]>(undefined);
    private dailyActivityTotals$ = new BehaviorSubject<any>(undefined);

    /**
     * Return the user list daily activity totals
     */
    selectUserListDailyActivityTotals() {
        return this.dailyActivityTotals$.asObservable();
    }

    /**
     * Return all user
     */
    selectUserFetchAll(): Observable<IUserListResponse> {
        return this.list$.asObservable();
    }

    selectUserListSwipes(): Observable<ISwipeResponse[]> {
      return this.swipes$.asObservable();
    }

    formatUser( user ) {
        const fullname      = user.fullname;
        const email         = user.email;
        const employeeNr    = user.employee_nr;
        let result;

        if ( employeeNr ) {
            result += `${employeeNr} -`;
        }
        if ( fullname ) {
            result += `${fullname.toLowerCase()}`;
        } else if ( email ) {
            result += `${email.toLowerCase()}`;
        } else {
            result += `Geen naam bekend`;
        }
    }

    /**
     * Search for user by query
     * @param {string} query The keywords to search on
     */
    selectUserSearchAll( query: string ): Observable<IUser[]> {
        if ( query ) {
            return this.selectUserFetchAll()
            .do( values => console.log( `[USER-SEARCH] query: ${query} in list`, values ) )
            .mergeMap( ( response ) => {
                return of( filter( response.items, user => {
                    return user.employee_nr && `${user.employee_nr}`.indexOf( query.toLowerCase() ) !== -1 ||
                        user.fullname && user.fullname.toLowerCase().indexOf( query.toLowerCase() ) !== -1 ||
                        user.email && user.email.toLowerCase().indexOf( query.toLowerCase() ) !== -1;
                } ) );
            } );
        } else {
            return this.selectUserFetchAll().map( response => response.items );
        }
    }

    /**
     * Select user by id
     * @param {number} userId User ID to select
     */
    selectUserByIdFetch( userId: number ): Observable<IUser> {
        if ( isNumber( userId ) ) {
            return this.selectUserFetchAll()
            .do( values => console.log( `[USER-SEARCH] find: ${userId} in list`, values ) )
            .mergeMap( ( response ) => of( find( get( response, 'items', [] ) as IUser[], user => user.id === userId ) as IUser ) );
        } else {
            return empty();
        }
    }

    selectNextUserByIdFetch( userId: number ): Observable<IUser> {
        console.log( '[DEBUG] selectNextUserByIdFetch', userId );
        if ( isNumber( userId ) ) {
            return this.selectUserFetchAll()
            .do( values => console.log( `[USER-SEARCH] next user for: ${userId} in list`, values ) )
            .mergeMap( ( response ) => {
                const currentIndex = findIndex( response.items, user => user.id === userId );
                return of( response.items[ ( currentIndex + 1 ) % response.items.length ] );
            } );
        } else {
            return empty();
        }
    }

    selectPreviousUserByIdFetch( userId: number ): Observable<IUser> {
        if ( isNumber( userId ) ) {
            return this.selectUserFetchAll()
            .do( values => console.log( `[USER-SEARCH] previous user for: ${userId} in list`, values ) )
            .mergeMap( ( response ) => {
                const currentIndex = findIndex( response.items, user => user.id === userId );
                return of( response.items[ ( currentIndex + response.items.length - 1 ) % response.items.length ] );
            } );
        } else {
            return empty();
        }
    }

    /**
     * Retrieve a list of all users
     */
    dispatchUserFetchAll( limit = 1000, skip = 0, sortField?: string, sortDirection?: string ): void {
        console.log( '[USERS] Retrieve all user' );
        this.$api.genericListCall( '/admin/users', limit, skip, sortField, sortDirection ).subscribe( ( response: IUserListResponse ) => {
            this.list$.next( response );
        } );
    }

    /**
     * Updates the user
     */
    dispatchUserUpdate( userId: number, user: Partial<IUser> ): Observable<IUser> {
        return this.$api.genericPutCall(`/admin/users/${userId}`, user ) as Observable<IUser>;
    }

    /**
     * @param {number} year
     * @param {number} isoWeek
     * @param {number} isoDay
     */
    dispatchUserListDailyActivityTotals( year: number, isoWeek: number, isoDay: number ) {
        this.$api.genericGetCall( `/admin/users/activities/${year}/${isoWeek}/${isoDay}` ).subscribe( ( response: any ) => {
            this.dailyActivityTotals$.next( response );
        } );
    }

    /**
     * @param userId
     * @param isoWeek
     * @param year
     */
    dispatchUserListSwipes( userId: number, isoWeek: number, year: number ): void {
      this.$api.genericGetCall( `/admin/users/${userId}/swipes/${year}/${isoWeek}?sortField=created_at&sortDirection=DESC` ).subscribe( ( response: ISwipeResponse[] ) => {
        this.swipes$.next( response );
      } );
    }
}



// WEBPACK FOOTER //
// ./src/providers/user.service.ts